const pushServerPublicKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;

if (!window.Notification) {
  window.Notification =
    window.Notification ||
    window.webkitNotification ||
    window.mozNotification ||
    window.oNotification ||
    window.msNotification;

  if (!window.Notification) {
    /* eslint-disable */
    window.Notification = function () {};
    window.Notification.permission = 'default';
    window.Notification.requestPermission = function () {
      return Promise.resolve('default');
    };
    /* eslint-enable */
  }
}

/**
 * checks if Push notification and service workers are supported by your browser
 */
function isPushNotificationSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window;
}

/**
 * asks user consent to receive push notifications and returns the response of the user, one of granted, default, denied
 */
async function askUserPermission() {
  await Notification.requestPermission();
}

/**
 * register a serviceworker
 */
function registerServiceWorker() {
  return navigator.serviceWorker.register('/sw.js');
}

/**
 *
 * using the registered service worker creates a push notification subscription and returns it
 *
 */
async function createNotificationSubscription() {
  const serviceWorker = await navigator.serviceWorker.ready;

  if (
    serviceWorker &&
    serviceWorker.pushManager &&
    serviceWorker.pushManager.subscribe
  ) {
    // subscribe and return the subscription
    const pushSubscriptionPayload = await serviceWorker.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: pushServerPublicKey,
    });

    if (serviceWorker.pushManager.getSubscription) {
      serviceWorker.pushManager.getSubscription().then((sub) => {
        const p256dh = sub.getKey('p256dh');
        const auth = sub.getKey('auth');
        // need to convert from ArrayBuffers to usable format (i.e. strings)
        const authArray = new Uint8Array(auth);
        const p256dhUInt8Array = new Uint8Array(p256dh);
        const authString = btoa(String.fromCharCode.apply(null, authArray));
        const p256dhUInt8String = btoa(
          String.fromCharCode.apply(null, p256dhUInt8Array)
        );

        pushSubscriptionPayload.p256dh = p256dhUInt8String;
        pushSubscriptionPayload.auth = authString;
      });
    }

    return pushSubscriptionPayload;
  }
}

/**
 * returns the subscription if present or nothing
 */
function getUserSubscription() {
  // wait for service worker installation to be ready, and then
  return navigator.serviceWorker.ready
    .then((serviceWorker) => {
      return serviceWorker.pushManager.getSubscription();
    })
    .then((pushSubscription) => {
      return pushSubscription;
    });
}

export {
  isPushNotificationSupported,
  askUserPermission,
  registerServiceWorker,
  createNotificationSubscription,
  getUserSubscription,
};
